const env = {
  API: "https://9gniphqi64.execute-api.ap-southeast-2.amazonaws.com",
  USER_POOL_CLIENT_ID: "",
  USER_POOL_ID: "",
  STRIPE: "",
};

module.exports = env;
